import React, { Suspense, ReactNode } from 'react';
import Loading from './Loading';

interface LazyPageWrapperProps {
  children: ReactNode;
  fallbackMessage?: string;
  fallbackTime?: number;
}

const LazyPageWrapper: React.FC<LazyPageWrapperProps> = ({ 
  children, 
  fallbackMessage = "Loading...", 
  fallbackTime = 1000 
}) => {
  return (
    <Suspense fallback={
      <Loading 
        isLoading={true} 
        message={fallbackMessage}
      />
    }>
      {children}
    </Suspense>
  );
};

export default LazyPageWrapper;
